var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('choice-table',{attrs:{"width":"60%","api":"/api/sys/role/list","choiceType":_vm.choiceType,"searchField":[{ type: 'input', code: 'code', name: '角色编码' }],"tableColumns":[
      { code: 'code', name: '角色编码' },
      { code: 'name', name: '名称' },
      { code: 'groupName', name: '分组名称' },
      { code: 'descs', name: '描述' } ],"title":"请选择角色","dialogVisible":_vm.dialogVisible},on:{"close":function($event){return _vm.$emit('dialogVisibleClose',false)},"choiced":function($event){return _vm.$emit('choiced',$event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }